import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Mapsec from '../sections/map-sec';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';
const Map = () => {
                  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( <>
                <main className='home-background'>

                    <Headerr />
                    <Mapsec />
                    <Navbar />

            </main>
    </> );
}
 
export default Map;